module.exports = __webpack_public_path__ + "media/images/home/feature/management_stafflist-4bf4ffb33b1f0b9cfd267439461bc908.png";